module.exports = "/images/SP.png?b6b1dfe726f0dd8ef36167237178ef48";